module.exports = __webpack_public_path__ + "static/kinoflo-0aae0ed3592e5db4827cd44b319af870.png";